export default __webpack_public_path__ + "static/media/16.48f0d1d4.png";